import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const utilitiesAPI = createApi({
  reducerPath: "utilitiesAPI",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getStates: builder.query({
      query: () => ({
        method: "GET",
        url: `/api/utility/locations/?all=True`,
      }),
    }),
    getCitiesByState: builder.query({
      query: (state) => ({
        method: "GET",
        url: `/api/utility/locations/?all=True`,
        params: state ? { state } : {},
      }),
    }),
    getActiveLocations: builder.query({
      query: () => ({
        method: "GET",
        url: `/api/utility/locations/?all=false`,
      }),
    }),
    getServiceableCities: builder.query({
      query: () => ({
        method: "GET",
        url: `/api/utility/serviceble-cities/`,
      }),
    }),
  }),
});

export const {
  useGetStatesQuery,
  useLazyGetStatesQuery,
  useGetCitiesByStateQuery,
  useLazyGetCitiesByStateQuery,
  useGetActiveLocationsQuery,
  useLazyGetActiveLocationsQuery,
  useGetServiceableCitiesQuery,
  useLazyGetServiceableCitiesQuery,
} = utilitiesAPI;

export default utilitiesAPI;
